import { GraphQLQueryClass } from "@harea/component"
import { TDebauchage, TDebauchagesResponse } from "@harea/component"

export class DebauchagesQuery implements GraphQLQueryClass<TDebauchagesResponse, TResponse> {
    public queryKey: string = "App.Harea.Debauchage"
    public gql: string = `
        query DebauchageListQuery(
            $data: JSONObject
            $pageSize: Float
            $page: Float
            $sort: [TFilterSort!]
        ) {
            debauchages(
                filter: { data: $data, pageSize: $pageSize, page: $page, sort: $sort }
            ) {
                total
                data {
                    id
                    createdAt
                    departureType
                    effectiveDate
                    reason
                    severancePay
                    noticePeriodDays
                    unpaidLeaveDays
                    status
                    calculatedIndemnities {
                        severancePay
                        noticePeriodCompensation
                        unpaidLeaveCompensation
                        total
                    }
                    personnel {
                        id
                        fullName
                        matricule
                        profilePicture { id }
                        department { id designation }
                    }
                    resignationLetter { id name }
                    dismissalPV { id name }
                    soldeDeToutCompte { id name }
                }
            }
        }
    `
    variables?: any

    constructor(variables?: any) {
        this.variables = {
            ...variables,
            data: {
                ...variables?.data,
                organisation: variables?.orgId ? { id: variables.orgId } : undefined,
            },
        }
    }

    mapFn(data: TResponse): TDebauchagesResponse {
        return {
            total: data.debauchages.total,
            data: data.debauchages.data,
        }
    }
}

export type TResponse = {
    debauchages: {
        total: number
        data: Array<TDebauchage>
    }
}
